import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter, Observable } from "rxjs";
import { User } from "src/app/models/user.model";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: 'app-admin-shell',
  templateUrl: './admin-shell.component.html',
  styleUrls: ['./admin-shell.component.scss'],
  imports: [RouterModule, CommonModule],
  standalone: true
})
export class AdminShellComponent implements OnInit {
  menuOpen = false;
 user$: Observable<User | null>;
 currentRoute: string = '';
  constructor(public auth: AuthService, private router: Router) {}
ngOnInit(){
  this.user$ = this.auth.user$;
  this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
    this.currentRoute = event.urlAfterRedirects;
  });

}
  get isAdmin$(): Observable<boolean> {
    return this.auth.hasRole('admin');
  }
  get isManagerOnly() {
    return this.auth.hasRole('manager') && !this.auth.hasRole('admin');
  }
async logout() {
    await this.auth.logout();
    this.router.navigateByUrl('/login');
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
   goToApply() {
    this.router.navigate(['/apply']);
  }

  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/pay']);
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
  goToDashboard() {
    this.router.navigate(['/tenant']);
  }
}
